import { useState, useEffect, useCallback } from "react";
import { Download, FileText } from "lucide-react";
import AppShell from "../components/layout/AppShell";
import ReportFilters from "../components/reports/ReportFilters";
import SalesReport from "../components/reports/SalesReport";
import CommissionsReport from "../components/reports/CommissionsReport";
import PaymentsReport from "../components/reports/PaymentsReport";
import BrokerRanking from "../components/reports/BrokerRanking";
import { AlertsPanel } from "../components/reports/AlertsPanel";
import api from "../services/api";

var TABS = [
  { key: "vendas", label: "Vendas" },
  { key: "comissoes", label: "Comissoes" },
  { key: "pagamentos", label: "Pagamentos" },
  { key: "ranking", label: "Ranking" },
  { key: "alertas", label: "Alertas" },
];

export default function ReportsPage() {
  var tabState = useState("vendas");
  var tab = tabState[0];
  var setTab = tabState[1];
  var loadingState = useState(true);
  var loading = loadingState[0];
  var setLoading = loadingState[1];
  var salesState = useState(null);
  var sales = salesState[0];
  var setSales = salesState[1];
  var commissionsState = useState(null);
  var commissions = commissionsState[0];
  var setCommissions = commissionsState[1];
  var paymentsState = useState(null);
  var payments = paymentsState[0];
  var setPayments = paymentsState[1];
  var rankingState = useState(null);
  var ranking = rankingState[0];
  var setRanking = rankingState[1];
  var alertsState = useState([]);
  var alerts = alertsState[0];
  var setAlerts = alertsState[1];
  var filtersState = useState(function() {
    var now = new Date();
    var s = new Date(now.getFullYear(), now.getMonth() - 5, 1);
    return { start_date: s.toISOString().split("T")[0], end_date: now.toISOString().split("T")[0] };
  });
  var filters = filtersState[0];
  var setFilters = filtersState[1];

  var fetchData = useCallback(function(f) {
    setLoading(true);
    var params = f || filters;
    var qs = "?start_date=" + params.start_date + "&end_date=" + params.end_date;
    Promise.all([
      api.get("/reports/sales" + qs),
      api.get("/reports/commissions" + qs),
      api.get("/reports/payments"),
      api.get("/reports/ranking"),
      api.get("/reports/alerts"),
    ]).then(function(results) {
      setSales(results[0].data);
      setCommissions(results[1].data);
      setPayments(results[2].data);
      setRanking(results[3].data);
      setAlerts(results[4].data.alerts || []);
    }).catch(function(err) {
      console.error("Erro ao carregar relatorios:", err);
    }).finally(function() {
      setLoading(false);
    });
  }, [filters]);

  useEffect(function() { fetchData(); }, [fetchData]);

  function handleFilter(newFilters) {
    setFilters(newFilters);
    fetchData(newFilters);
  }

  function handleExportCSV(type) {
    api.get("/reports/export/csv?report_type=" + type, { responseType: "blob" }).then(function(res) {
      var blob = new Blob([res.data], { type: "text/csv" });
      var url = URL.createObjectURL(blob);
      var a = document.createElement("a");
      a.href = url;
      a.download = "relatorio_" + type + ".csv";
      a.click();
      URL.revokeObjectURL(url);
    });
  }

  function handleExportPDF() {
    api.get("/reports/export/pdf?start_date=" + filters.start_date + "&end_date=" + filters.end_date, { responseType: "blob" }).then(function(res) {
      var blob = new Blob([res.data], { type: "application/pdf" });
      var url = URL.createObjectURL(blob);
      var a = document.createElement("a");
      a.href = url;
      a.download = "relatorio_methos.pdf";
      a.click();
      URL.revokeObjectURL(url);
    });
  }

  var alertCount = alerts.filter(function(a) { return a.severity === "high"; }).length;

  return (
    <AppShell activePage="relatorios" title="Relatorios">
      <div data-testid="reports-page">
        <div className="flex flex-wrap items-center justify-between gap-3 mb-4">
          <ReportFilters onFilter={handleFilter} />
          <div className="flex gap-2">
            {tab === "vendas" && (
              <button onClick={function() { handleExportCSV("leads"); }} className="flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-xs font-medium bg-emerald-50 text-emerald-700 hover:bg-emerald-100 transition-colors border border-emerald-200" data-testid="export-csv-leads">
                <Download className="w-3.5 h-3.5" />CSV Leads
              </button>
            )}
            {tab === "comissoes" && (
              <button onClick={function() { handleExportCSV("commissions"); }} className="flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-xs font-medium bg-emerald-50 text-emerald-700 hover:bg-emerald-100 transition-colors border border-emerald-200" data-testid="export-csv-commissions">
                <Download className="w-3.5 h-3.5" />CSV Comissoes
              </button>
            )}
            {tab === "pagamentos" && (
              <button onClick={function() { handleExportCSV("payments"); }} className="flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-xs font-medium bg-emerald-50 text-emerald-700 hover:bg-emerald-100 transition-colors border border-emerald-200" data-testid="export-csv-payments">
                <Download className="w-3.5 h-3.5" />CSV Pagamentos
              </button>
            )}
            <button onClick={handleExportPDF} className="flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-xs font-medium bg-red-50 text-red-700 hover:bg-red-100 transition-colors border border-red-200" data-testid="export-pdf">
              <FileText className="w-3.5 h-3.5" />Exportar PDF
            </button>
          </div>
        </div>

        <div className="flex gap-1 mb-6 bg-gray-100 rounded-xl p-1 overflow-x-auto">
          {TABS.map(function(t) {
            var active = tab === t.key;
            var badge = t.key === "alertas" && alertCount > 0 ? alertCount : null;
            return (
              <button
                key={t.key}
                data-testid={"tab-" + t.key}
                onClick={function() { setTab(t.key); }}
                className={"flex-shrink-0 flex items-center gap-1.5 px-4 py-2 rounded-lg text-sm font-medium transition-all " + (active ? "bg-white text-[#0A2F3D] shadow-sm" : "text-gray-500 hover:text-gray-700")}
              >
                {t.label}
                {badge && <span className="w-5 h-5 rounded-full bg-red-500 text-white text-[10px] flex items-center justify-center font-bold">{badge}</span>}
              </button>
            );
          })}
        </div>

        {loading ? (
          <div className="flex items-center justify-center py-20">
            <div className="w-8 h-8 border-3 border-[#3B82F6] border-t-transparent rounded-full animate-spin" />
          </div>
        ) : (
          <div>
            {tab === "vendas" && <SalesReport data={sales} />}
            {tab === "comissoes" && <CommissionsReport data={commissions} />}
            {tab === "pagamentos" && <PaymentsReport data={payments} />}
            {tab === "ranking" && <BrokerRanking data={ranking} />}
            {tab === "alertas" && <AlertsPanel alerts={alerts} />}
          </div>
        )}
      </div>
    </AppShell>
  );
}
